import { InternalTaskFilters } from "@jugl-web/rest-api/tasks";

export const INITIAL_TASK_FILTERS_STATE: InternalTaskFilters = {
  boards: [],
  inventoryItems: [],
  labels: [],
  priorities: [],
  statuses: [],
  assignees: [],
  customers: [],
  customFields: {},
  isOverdue: null,
  isRecurring: null,
};
